import * as THREE from 'three';
import { profile } from './profile.js';
import { combine, ribbon, shade } from './surface.js';

const FOOT = [
  [-.22, .052, .030, -.015], [-.17, .087, .050, -.002],
  [-.075, .096, .082, .025], [.045, .108, .052, -.002],
  [.16, .107, .040, -.012], [.24, .070, .027, -.02], [.26, .025, .017, -.025]
];

function upper(shoe = false) {
  const rings = FOOT.map(([z, width, height, center]) => ({
    y: z * (shoe ? 1.06 : 1), rx: width + (shoe ? .016 : 0),
    rz: height + (shoe ? .018 : 0), z: -center - (shoe ? .006 : 0)
  }));
  return profile(rings, { segments: 8, power: .72 }).rotateX(Math.PI / 2);
}

function sole() {
  return profile([
    { y: -.08, rx: .123, rz: .249, z: .023 },
    { y: -.073, rx: .132, rz: .258, z: .023 },
    { y: -.048, rx: .132, rz: .258, z: .023 },
    { y: -.042, rx: .124, rz: .251, z: .023 }
  ], { segments: 12, power: .60 });
}

export function buildFootwear() {
  const foot = upper(), shell = upper(true);
  const mat = new THREE.MeshBasicMaterial(), ray = new THREE.Raycaster();
  const skin = new THREE.Mesh(foot, mat), shoeSurface = new THREE.Mesh(shell, mat);
  skin.updateMatrixWorld(true); shoeSurface.updateMatrixWorld(true);
  const height = (mesh, x, z) => {
    ray.set(new THREE.Vector3(x, .5, z), new THREE.Vector3(0, -1, 0));
    return ray.intersectObject(mesh)[0]?.point.y ?? -.045;
  };
  const arch = (mesh, z, width, span, steps = 6) => ribbon(Array.from({ length: steps + 1 }, (_, i) => {
    const x = (i / steps - .5) * span;
    return [x, height(mesh, x, z) + .016, z];
  }), width);

  const laces = [.075, .115, .155].map(z => shade(arch(shoeSurface, z, .010, .13, 4), .32));
  const shoes = combine([shade(shell), shade(sole(), .16), ...laces]);
  const flipStraps = [-1, 1].map(side => ribbon(Array.from({ length: 7 }, (_, i) => {
    const t = i / 6, x = side * .126 * t, z = .17 - .25 * t;
    return [x, height(skin, x, z) + .015, z];
  }), .035));
  const peg = new THREE.CylinderGeometry(.011, .011, .033, 6).translate(0, -.004, .17);
  const flipflops = combine([shade(sole(), .65), ...flipStraps, peg]);

  const heel = ribbon(Array.from({ length: 9 }, (_, i) => {
    const a = Math.PI * i / 8;
    return [Math.cos(a) * .106, .073 + .022 * Math.sin(a), -.082 - .116 * Math.sin(a)];
  }), .03, .014);
  const sandals = combine([shade(sole(), .55), arch(skin, .095, .052, .25), arch(skin, -.065, .045, .245), heel]);
  mat.dispose();
  return { foot, shoes, flipflops, sandals };
}
